import url from "./url";
const apiUrl = `${url}dashboard/`;
const apis = {
  apiUrl: apiUrl,
  login: `${url}auth/login`,
  loadScada: `${apiUrl}loadScada`,
  loadScadaWithMult: `${apiUrl}load_scada_with_mult`,
  obtainGraph: `${apiUrl}obtaingraph`,
  obtainGraphWithMult: `${apiUrl}obtain_graph_with_mult`,
  getAlarm: `${apiUrl}getAlarm`,
  setAlarm: `${apiUrl}setAlarm`,
  setScadaAlarm: `${apiUrl}setScadaAlarm`,
  getAlarmEvents: `${apiUrl}getAlarmEvents`,
  listLog: `${apiUrl}list_log`,
  setAlarmComment: `${apiUrl}setAlarmComment`,
  updateUser: `${apiUrl}update_user`,
  resetPassword: `${apiUrl}reset_password`,
  deleteUser: `${apiUrl}delete_user`,
  listUser: `${apiUrl}list_user`,
  createUser: `${apiUrl}create_user_2`,
  informar: `${apiUrl}informar`,
  exportData: `${url}report/action`,
  multiExportData: `${url}report/multiExport`,
  alarmReport: `${url}report/alarm_report`,
  getTokenResponse: `${url}user/getTokenResponse`,
  insertarPlanta: `${apiUrl}insertarPlanta`,
  getMenusPlantas: `${apiUrl}getMenuPlantas`,
  getLimitesPlcGrafico: `${apiUrl}getLimitesPlcGrafico`,
  updateLimitesPlcGrafico: `${apiUrl}updateLimitesPlcGrafico`,
  insertarVisita: `${apiUrl}insertar_visita`,
  getVisitasPorPlanta: `${apiUrl}get_visitas_por_planta`,
  getEstadoPlantas: `${apiUrl}get_estado_plantas`,
  getPlantas: `${apiUrl}get_plantas`,
  getPerfiles: `${apiUrl}get_perfiles`,
  bloquearUsuario: `${apiUrl}bloquear_usuario`,
  getInfoGeneralPlanta: `${apiUrl}get_info_general_planta`,
  exportarTotalizadores: `${url}report/exportar_totalizadores`,
  exportarTotalizadoresCariant: `${url}report/exportar_totalizadores_clariant`,
  //normalizacion
  normalizacionDow: `${apiUrl}getDatosNormalizacionDow`,
  getMantencionMembranas: `${apiUrl}getMantencionMembranas`,
  exportarDatosNormDow: `${url}report/exportarNormalizacion`,
  insertDatoNormSeleccion: `${apiUrl}insertDatoNormSeleccion`,
  getDatosNormSeleccion: `${apiUrl}getDatosNormSeleccion`,
  insertMantencionMembranas: `${apiUrl}insertMantencionMembranas`,
  getUltimaAlarma: `${apiUrl}getUltimaAlarma`,
  getLimitesNormalizacion: `${apiUrl}getLimitesNormalizacion`,
  updateLimitesNormalizacion: `${apiUrl}updateLimitesNormalizacion`,
  getRangosGraficosNorm: `${apiUrl}get_rangos_norm`,
  updateRangosGraficosNorm: `${apiUrl}update_norm_rango_grafico`,
  getNormalizacionConfiguracion: `${apiUrl}getNormalizacionConfiguracion`,
  saveNormalizacionConfiguracion: `${apiUrl}saveNormalizacionConfiguracion`,
  //sealand
  setAlarmSealand: `${apiUrl}setAlarmSealand`
};

export default apis;
